import React, { useContext, useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { Grid, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { PhotoCamera } from '@material-ui/icons';
import { db, storage } from '../../firebase';
import { AuthContext } from '../../contexts/AuthContext';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Card } from '../Card/Card';
import CardContent from '@material-ui/core/CardContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AvatarEditor from 'react-avatar-editor';

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    height: '150px',
    width: '150px',
    textAlign: 'center',
    boxShadow: '0px 0px 10px 0px #000',
  },
  profileCardHeader: {
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      width: '50px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '75px',
      width: '75px',
    },
    textAlign: 'left',
  },

  input: {
    display: 'none',
  },
  profileHeader: {
    height: '50px',
    width: '50px',
    marginBottom: '-30px',
  },
}));

export function ProfileCardHeader(props) {
  const { currentUser } = useContext(AuthContext);
  const { src, alt, type, isPublicView, ...rest } = props;
  const [image, setImage] = useState<any>('');
  const [inputImage, setInputImage] = useState<any>();
  const [imageScale, setImageScale] = useState<number | number[]>(1);
  const [profilePictureDialog, setProfilePictureDialog] = useState(false);
  const classes = useStyles();
  const onClickHandler = () => {
    try {
      const profilePicture = storage.child(`profile-pictures/${currentUser.uid}/dp.jpg`);
      profilePicture.put(inputImage).then((snapshot) => {
        storage
          .child(`profile-pictures/${currentUser.uid}/dp.jpg`)
          .getDownloadURL()
          .then((url) => {
            setImage(url);
            db.collection('profile').doc(currentUser.uid).update({ dp_url: url }).then();
          });
        console.log('Uploaded a blob or file!');
      });
      setProfilePictureDialog(false);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    storage
      .child(`profile-pictures/${currentUser.uid}/dp.jpg`)
      .getDownloadURL()
      .then((url) => {
        setImage(url);
        setInputImage(url);
      })
      .catch((error) => {
        // Handle any errors
      });
  }, []);
  return (
    <div>
      {type !== 'Profile Card' ? (
        <div
          style={{
            position: 'relative',
            height: '150px',
            width: '150px',
            margin: '-75px auto 0',
          }}
        >
          {!isPublicView ? (
            <Avatar alt={alt} src={image} {...rest} className={classes.cardHeader} />
          ) : (
            <Avatar alt={alt} src={src} {...rest} className={classes.cardHeader} />
          )}
          {!isPublicView && (
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              size="medium"
              onClick={() => setProfilePictureDialog(true)}
              style={{
                right: '0px',
                bottom: '0px',
                position: 'absolute',
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              }}
            >
              <PhotoCamera />
            </IconButton>
          )}
          <Dialog open={profilePictureDialog} onClose={() => setProfilePictureDialog(false)}>
            <DialogTitle>Update Profile Picture</DialogTitle>
            <DialogContent>
              <DialogContentText>Select and adjust your profile picture</DialogContentText>
              <div>
                <Card elevation={3} style={{ marginTop: '20px' }}>
                  <CardContent>
                    <Grid container>
                      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        {inputImage && (
                          <AvatarEditor
                            image={inputImage}
                            width={250}
                            height={250}
                            border={50}
                            borderRadius={200}
                            color={[255, 255, 255, 0.6]} // RGBA
                            scale={imageScale}
                            rotate={0}
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        style={{ display: 'flex', justifyContent: 'center', margin: '20px auto 0' }}
                      >
                        {/*<Slider*/}
                        {/*  value={imageScale}*/}
                        {/*  step={0.1}*/}
                        {/*  min={1}*/}
                        {/*  max={1.9}*/}
                        {/*  onChange={(e, value) => setImageScale(value)}*/}
                        {/*  aria-labelledby="continuous-slider"*/}
                        {/*/>*/}
                      </Grid>
                      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <input
                          accept="image/*"
                          className={classes.input}
                          id="contained-button-file"
                          multiple
                          name="profilePicture"
                          type="file"
                          onChange={(e) => setInputImage(e.target.files[0])}
                        />
                        <label htmlFor="contained-button-file">
                          <Button variant="contained" color="primary" component="span">
                            Upload
                          </Button>
                        </label>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                {/*{inputList.length - 1 === i && <Button size="small" onClick={handleAddClick} style={{float: "right", margin: "10px"}}><AddCircleOutlineIcon color="secondary" fontSize='large' /></Button>}*/}
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <Button
                onClick={() => setProfilePictureDialog(false)}
                color="primary"
                style={{ marginLeft: '10px' }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={onClickHandler}
                color="primary"
                style={{ marginRight: '10px', float: 'right' }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : (
        <div className={classes.profileHeader}>
          <Avatar alt={alt} src={src} {...rest} className={classes.profileCardHeader} />
        </div>
      )}
    </div>
  );
}
